import React from "react";
import "./popularSpaceBtn.css";

export default function PopularSpaceBtn({ image, label, area, totalSpaces }) {
  return (
    <button
      className={`popular-space-btn`}
      aria-label={`Klicka för att se mer om ${label}, en populär lokaltyp med area mellan ${area} kvadratmeter och totalt ${totalSpaces} tillgängliga lokaler.`}
    >
      <img
        src={image}
        alt={label}
        className="popular-space-image"
        width="300"
        height="200"
      />
      <div className="popular-space-overlay"></div>
      <h3>{label}</h3>
      <p>{area} m²</p>
      <p className="total-spaces">{totalSpaces} st</p>
    </button>
  );
}
